import BaseFormModel from '@/lib/models/base-form-model';
import modelsStore from '@/lib/services/models-store';
import defineMethodsChildren from '@/lib/helpers/define-methods-children';

import store from '@/store';

import defineProperty from '@/lib/helpers/define-property';

import {
  FORM_TYPE,
  STEP_TYPE,
} from '@/lib/constants/model-types';


class Form extends BaseFormModel {
  constructor(component, { name }) {
    super(component);

    defineProperty(this, 'name');
    this.name = name;

    defineMethodsChildren(this, {
      selfName: 'form',
      namePlural: 'steps',
      nameSingular: 'step',
      type: STEP_TYPE,
    });
  }

  findByName(name) {
    return this.steps.find(step => step.name === name);
  }

  get isEditable() {
    return this.transactionalBlockers.length === 0;
  }

  get isLoading() {
    return this.loaders.length > 0
      || this.steps.some(step => step.isLoading);
  }

  static get $modelType() {
    return FORM_TYPE;
  }

  static get mainForm() {
    const firstForm = Object.keys(store.state.forms)[0];
    const model = modelsStore.modelForId(FORM_TYPE, firstForm);

    return model;
  }

  get fields() {
    const { steps } = this;
    const fields = steps.flatMap(f => f.fields);

    return fields;
  }

  get allFields() {
    const { allSteps } = this;
    const fields = allSteps.flatMap(f => f.allFields);

    return fields;
  }

  getField(name) {
    const field = this.fields.find(f => f.name === name);
    return field;
  }

  getFieldEvenNotPresent(name) {
    const field = this.allFields.find(f => f.name === name);
    return field;
  }
}

modelsStore.registerClass(Form);

export default Form;
